var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.418 134.248C295.087 125.917 281.579 125.917 273.248 134.248C264.917 142.579 264.917 156.087 273.248 164.418L364.83 256L273.248 347.582C264.917 355.913 264.917 369.421 273.248 377.752C281.579 386.083 295.087 386.083 303.418 377.752L410.085 271.085C418.416 262.754 418.416 249.246 410.085 240.915L303.418 134.248Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.418 134.248C146.087 125.917 132.579 125.917 124.248 134.248C115.917 142.579 115.917 156.087 124.248 164.418L215.83 256L124.248 347.582C115.917 355.913 115.917 369.421 124.248 377.752C132.579 386.083 146.087 386.083 154.418 377.752L261.085 271.085C269.416 262.754 269.416 249.246 261.085 240.915L154.418 134.248Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.6c1b830d29b8a4bd8c8d73ecc9d9bc6c.svg";
export { ForwardRef as ReactComponent };